/** @jsxImportSource @emotion/react */
"use client";

import type { Interpolation } from "@emotion/react";
import { HallowAnalyticsEvent, useAnalytics } from "@packages/analytics";
import type { CarouselApi } from "@packages/ui";
import { numericPercentages, spacing, Text } from "@packages/ui";
import { DialogTitle } from "@radix-ui/react-dialog";
import { useCallback, useState } from "react";

import { ModalCarousel } from "./ModalCarousel.emotion";
import type { RenderableItem } from "./PostPrayerModal.emotion";

const titleStyle: Interpolation = {
  left: numericPercentages[50],
  position: "absolute",
  textAlign: "center",
  top: 31,
  transform: "translateX(-50%)",
  width: spacing.full,
};
export const PostPrayerModalContent = ({
  items,
  carouselApi,
}: {
  items: RenderableItem[];
  carouselApi: CarouselApi;
}) => {
  const [title, setTitle] = useState<string>("");
  const analytics = useAnalytics();

  const handleVisibility = useCallback(
    (idx: number) => {
      setTitle(items[idx].title);
      analytics.track({
        event: HallowAnalyticsEvent.ViewedPostPrayerScreen,
        properties: { screen_name: items[idx].type },
      });
      analytics.postEvent({ event: `post-prayer-seen-${items[idx].id}` });
    },
    [items, analytics],
  );

  return (
    <>
      <DialogTitle asChild>
        <Text as={"h2"} type={"title"} size={"m"} css={titleStyle}>
          {title}
        </Text>
      </DialogTitle>
      <ModalCarousel onVisible={handleVisibility} carouselApi={carouselApi}>
        {items.map((obj) => obj.element)}
      </ModalCarousel>
    </>
  );
};
